import * as React from "react";
import { Icon } from "../actions/Icon";

/**
 * Placeholder for an empty library, search or notification list: an icon disc, a title, one line
 * of description and at most one action.
 */
export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  /** Phosphor icon name. Default "video-camera". */
  icon?: string;
  title: string;
  description?: React.ReactNode;
  /** Usually a single Button. One action, never two. */
  action?: React.ReactNode;
  /** Element for the title, to fit the page's heading outline. Default "h3". */
  titleAs?: "h2" | "h3" | "h4" | "p";
}

export function EmptyState({
  icon = "video-camera",
  title,
  description,
  action,
  titleAs: Title = "h3",
  className,
  ...rest
}: EmptyStateProps): JSX.Element {
  return (
    <div className={["gk-emptystate", className].filter(Boolean).join(" ")} {...rest}>
      <span className="gk-emptystate__icon">
        <Icon name={icon} size={24} />
      </span>
      <div>
        <Title className="gk-emptystate__title">{title}</Title>
        {description && <p className="gk-emptystate__desc">{description}</p>}
      </div>
      {action}
    </div>
  );
}
